import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const gotify = defineConnector({
  identifier: "gotify",
  name: "Gotify",
  tagLine: "Self-hosted push notification service",
  logo,
  protocol: "http",
  tags: ["communication"],
  auth: (app) =>
    headerAuth([{ name: "X-Gotify-Key", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Get your client or app token",
      items: [
        {
          kind: "markdown",
          content:
            "In the Gotify UI, create an application or client and copy its token.",
        },
      ],
    },
    {
      title: "Enter your Gotify details",
      items: [
        {
          kind: "url",
          label: "Gotify server URL",
          required: true,
          placeholder: "https://gotify.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Gotify server.",
        },
        {
          kind: "input",
          label: "Client or app token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/version`,
  },
});
